import { supabase } from './supabase'

let cachedEstablishmentId: string | null = null

export async function getCurrentEstablishmentId(): Promise<string> {
  if (cachedEstablishmentId) return cachedEstablishmentId

  const { data: { user }, error: userError } = await supabase.auth.getUser()
  if (userError || !user) throw userError || new Error('Sessão não encontrada.')

  const { data, error } = await supabase
    .from('profiles')
    .select('establishment_id')
    .eq('id', user.id)
    .single()

  if (error) throw error
  const establishmentId = data?.establishment_id
  if (!establishmentId) throw new Error('Usuário sem estabelecimento vinculado.')

  cachedEstablishmentId = establishmentId
  return establishmentId
}
